module.exports = __webpack_public_path__ + "img/02-all-cover.29fcfb02.png";